export default {
  pills: []
};
